;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import sortBy from "lodash/sortBy"
import reduce from "lodash/reduce"

type DayItem = {
  day: string
  starts_at: string
}

const ORDERED_DAYS_OF_THE_WEEK = [
  "sunday",
  "Sunday",
  "sun",
  "Sun",
  "monday",
  "Monday",
  "mon",
  "Mon",
  "tuesday",
  "Tuesday",
  "tue",
  "Tue",
  "wednesday",
  "Wednesday",
  "wed",
  "Wed",
  "thursday",
  "Thursday",
  "thu",
  "Thu",
  "friday",
  "Friday",
  "fri",
  "Fri",
  "saturday",
  "Saturday",
  "sat",
  "Sat",
]

export const formatTime = (unformatedTime: string): string => {
  return unformatedTime.replace(/:00/g, "")
}

export const orderDayOfWeekArray = <T extends { day: string }>(
  unorderedDayOfWeekArr: T[],
): T[] => {
  return sortBy(unorderedDayOfWeekArr, (day) => {
    return ORDERED_DAYS_OF_THE_WEEK.indexOf(day.day)
  })
}

export const daysAndStartTimesString = (days: DayItem[]): string => {
  const orderedDays = orderDayOfWeekArray(days)
  return reduce(
    orderedDays,
    (acc, { day, starts_at: startsAt }, index) => {
      const dayTime = `${day} ${formatTime(startsAt)}`
      if (index === 0) return acc + dayTime
      if (index === days.length - 1) return acc + " and " + dayTime
      return acc + ", " + dayTime
    },
    "",
  )
}
